const TermsPage = () => {
  return (
    <div className="relative z-10 min-h-screen bg-gradient-to-b from-white via-gray-50 to-white py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-[900px] mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary/10 text-secondary rounded-full mb-6 font-semibold text-sm">
              <i className="fas fa-file-contract"></i>
              <span>شروط الاستخدام</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-text mb-4">
              شروط الاستخدام
            </h1>
            <p className="text-xl text-text2">
              آخر تحديث: مارس 2026
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-xl border-2 border-gray-100 p-8 md:p-12 space-y-10">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-primary rounded-full"></span>
                الموافقة على الشروط
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                باستخدامك لمنصة Allemni، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه الشروط، يرجى عدم استخدام المنصة.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-secondary rounded-full"></span>
                التسجيل والحساب
              </h2>
              <div className="space-y-4 text-lg text-text2">
                <p className="leading-relaxed">عند إنشاء حساب على منصتنا، يجب عليك:</p>
                <ul className="space-y-3 mr-6">
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-secondary mt-1"></i>
                    <span>تقديم معلومات دقيقة وكاملة</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-secondary mt-1"></i>
                    <span>الحفاظ على سرية كلمة المرور الخاصة بك</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-secondary mt-1"></i>
                    <span>أن تكون مسؤولاً عن جميع الأنشطة التي تتم من خلال حسابك</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-secondary mt-1"></i>
                    <span>إخطارنا فوراً بأي استخدام غير مصرح به لحسابك</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-accent rounded-full"></span>
                الاشتراكات والدفع
              </h2>
              <div className="space-y-4 text-lg text-text2">
                <div className="bg-blue-50 p-6 rounded-xl border border-blue-200">
                  <h3 className="font-bold text-text mb-3 text-xl">الأسعار والفوترة</h3>
                  <ul className="space-y-2 mr-4">
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">•</span>
                      <span>جميع الأسعار معروضة بالدينار الجزائري (DZD)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">•</span>
                      <span>الاشتراكات تجدد تلقائياً ما لم يتم إلغاؤها</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">•</span>
                      <span>الدفع يتم عبر بوابة Chargily الآمنة</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-blue-600">•</span>
                      <span>يمكنك إلغاء اشتراكك في أي وقت من لوحة التحكم</span>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-green-500 rounded-full"></span>
                سياسة الاسترجاع
              </h2>
              <div className="bg-green-50 p-6 rounded-xl border border-green-200">
                <p className="text-lg text-text2 leading-relaxed mb-4">
                  يحق لك طلب استرجاع كامل المبلغ في الحالات التالية:
                </p>
                <ul className="space-y-2 text-text2 mr-4">
                  <li className="flex items-start gap-2">
                    <i className="fas fa-arrow-left text-green-600 mt-1"></i>
                    <span>خلال 7 أيام من تاريخ الشراء</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-arrow-left text-green-600 mt-1"></i>
                    <span>إذا لم تتمكن من الوصول إلى المحتوى لأسباب تقنية</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-arrow-left text-green-600 mt-1"></i>
                    <span>إذا كان المحتوى لا يتطابق مع الوصف المقدم</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-purple-500 rounded-full"></span>
                حقوق الملكية الفكرية
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                جميع محتويات المنصة (نصوص، صور، فيديوهات، دورات) محمية بموجب قوانين حقوق النشر الجزائرية والدولية.
              </p>
              <div className="bg-red-50 p-6 rounded-xl border border-red-200">
                <h3 className="font-bold text-text mb-3 flex items-center gap-2">
                  <i className="fas fa-ban text-red-600"></i>
                  <span>يُمنع منعاً باتاً:</span>
                </h3>
                <ul className="space-y-2 text-text2 mr-4">
                  <li className="flex items-start gap-2">
                    <span className="text-red-600">✗</span>
                    <span>نسخ أو توزيع المحتوى التعليمي</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-600">✗</span>
                    <span>مشاركة حسابك مع أشخاص آخرين</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-600">✗</span>
                    <span>تحميل المحتوى لإعادة بيعه أو توزيعه</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-red-600">✗</span>
                    <span>استخدام المحتوى لأغراض تجارية بدون إذن</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-orange-500 rounded-full"></span>
                السلوك المقبول
              </h2>
              <div className="space-y-4 text-lg text-text2">
                <p className="leading-relaxed">يجب على المستخدمين:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="p-4 bg-green-50 rounded-xl border border-green-200">
                    <h4 className="font-bold text-green-700 mb-2 flex items-center gap-2">
                      <i className="fas fa-check-circle"></i>
                      <span>المسموح</span>
                    </h4>
                    <ul className="space-y-1 text-sm">
                      <li>• احترام الآخرين</li>
                      <li>• المشاركة البناءة</li>
                      <li>• طلب المساعدة</li>
                      <li>• التعلم والتطور</li>
                    </ul>
                  </div>
                  <div className="p-4 bg-red-50 rounded-xl border border-red-200">
                    <h4 className="font-bold text-red-700 mb-2 flex items-center gap-2">
                      <i className="fas fa-times-circle"></i>
                      <span>الممنوع</span>
                    </h4>
                    <ul className="space-y-1 text-sm">
                      <li>• التحرش أو الإساءة</li>
                      <li>• نشر محتوى غير لائق</li>
                      <li>• محاولة اختراق المنصة</li>
                      <li>• إساءة استخدام الخدمة</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-pink-500 rounded-full"></span>
                إنهاء الحساب
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                نحتفظ بالحق في تعليق أو إنهاء حسابك في حالة:
              </p>
              <ul className="space-y-3 mr-6 text-lg text-text2">
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>انتهاك شروط الاستخدام</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>نشاط احتيالي أو مشبوه</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>عدم الدفع أو الدفع المرتجع</span>
                </li>
              </ul>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-indigo-500 rounded-full"></span>
                تحديد المسؤولية
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                نسعى لتقديم أفضل تجربة تعليمية، لكننا لا نضمن أن المنصة ستكون متاحة 100% من الوقت أو خالية تماماً من الأخطاء. نحن غير مسؤولين عن أي أضرار ناتجة عن استخدام أو عدم القدرة على استخدام المنصة.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-teal-500 rounded-full"></span>
                التعديلات على الشروط
              </h2>
              <div className="bg-yellow-50 p-6 rounded-xl border border-yellow-200">
                <p className="text-lg text-text2 leading-relaxed">
                  نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إشعارك بأي تغييرات جوهرية عبر البريد الإلكتروني أو من خلال إشعار على المنصة. استمرارك في استخدام المنصة بعد التعديلات يعني موافقتك على الشروط الجديدة.
                </p>
              </div>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-blue-500 rounded-full"></span>
                القانون الساري
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                تخضع هذه الشروط وتفسر وفقاً للقوانين المعمول بها في الجمهورية الجزائرية الديمقراطية الشعبية. أي نزاع ينشأ عن هذه الشروط يخضع للاختصاص الحصري للمحاكم الجزائرية.
              </p>
            </section>

            {/* Section 11 */}
            <section className="border-t-2 border-gray-200 pt-8">
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-primary rounded-full"></span>
                التواصل معنا
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                لأي استفسارات حول شروط الاستخدام، يرجى التواصل معنا:
              </p>
              <div className="flex flex-col gap-3 bg-gray-50 p-6 rounded-xl">
                <div className="flex items-center gap-3">
                  <i className="fas fa-envelope text-primary"></i>
                  <span className="text-lg" dir="ltr">info@allemani.dz</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-phone text-primary"></i>
                  <span className="text-lg" dir="ltr">0558501409</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-map-marker-alt text-primary"></i>
                  <span className="text-lg">قسنطينة، الجزائر</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
